import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import SMCModal from '../../components/core/SMCModal';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../components/Simple/SMCButton';
import SMCLabel from '../../components/Simple/SMCLabel';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import SMCPasswordInput from '../../components/Simple/SMCPasswordInput';

function DeleteServiceDomainConfirmPasswordModal({
    isOpen,
    onRequestClose,
    onFinish
}) {
    const { t } = useTranslation();

    const [password, setPassword] = useState('');

    const handleFinish = () => {
        onFinish(password);
    };

    useEffect(() => {
        if (isOpen) {
            setPassword('');
        }
    }, [isOpen]);

    return (
        <SMCModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            height={290}
            width={400}
            title={t('SMC_CONFIRMPASS_TITLE')}
        >
            <SMCModalBody lineHeight="22px">
                <SMCLabel>
                    {t('SMC_PORTALS_DELETE_QUES1')}
                    <br />
                    {t('SMC_PORTALS_DELETE_QUES2')}&nbsp;
                    <b>{t('SMC_PORTALS_DELETE_QUES3')}</b>
                    <br />
                    {t('SMC_PORTALS_DELETE_QUES4')}
                </SMCLabel>
                <SMCPasswordInput
                    style={{ marginTop: '8px' }}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    autoComplete="new-password" // set this so that google chrome doesn't try to autocomplete
                    allowPasswordPeek={true}
                />
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={handleFinish}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_OK')}
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>
    );
}

export default DeleteServiceDomainConfirmPasswordModal;